import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../Contexts/AuthContext";
import { getTodayTasks, markDone, markUnDone } from "../../../api/todoApi";
import { FcTodoList } from "react-icons/fc";
import { SiTodoist, SiHappycow  } from "react-icons/si";
import { CiCalendarDate } from "react-icons/ci";
import "./toDoToday.css";

export default function ToDoToday() {
  const { user } = useContext(AuthContext);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const today = new Date();

  useEffect(() => {
    setLoading(true);
    getTodayTasks(user.id).then(setTasks).finally(()=>setLoading(false));
  }, [user.id]);

  const handleDone = async (id) => {
    await markDone(id);
    setTasks(tasks =>
      tasks.map(t =>
        t.id === id ? { ...t, is_done: true } : t  
      )
    );
  }
  

  const handleUnDone = async (id) => {
    await markUnDone(id);
    setTasks(tasks =>
      tasks.map(t =>
        t.id === id ? { ...t, is_done: false } : t  
      )
    );
  };

  return (
    <div className={`todo-container ${loading ? 'loading' : ''}`}>
      <h2><FcTodoList /> À faire </h2>

      {loading && <p className="loading-message">Chargement...</p>}
      
      {!loading && tasks.length === 0 && <p className="Rien-a-faire">Rien à faire .</p>}
      
    
      {!loading && tasks.map(task => (
        <div
          key={task.id}
          className={`todo-item ${task.is_done ? "done" : "undone"}`}
        >
          <p className="todo-date"><CiCalendarDate />{task.todo_date}</p>
          <div className="description">
            <strong><SiTodoist /> {task.title}</strong>
            <p>{task.description}</p>  
            <p><SiHappycow /> Animal : {task.reproduction?.animal?.numero} - {task.reproduction?.animal?.nom}</p>
          </div> 

          {!task.is_done ? (
            <button onClick={() => handleDone(task.id)}>
              Done
            </button>
          ):(
            <button onClick={() => handleUnDone(task.id)}>
              Undo
            </button>
          )} 
        </div>
      ))}
    </div>
  );
}